import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  header: {
    position: 'relative',
  },
  buttonContainer: {
    position: 'absolute',
    right: 0,
  },
  buttonBox: {
    display: 'flex',
  },
  button: {
    margin: theme.spacing(0.2),
    minWidth: '160px',
  },
  modalContent: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  modalText: {
    color: theme.palette.tertiary.main,
    fontSize: 24,
    fontStyle: 'italic',
    fontWeight: '300',
  },
}));
